import { CollapsibleBase, CustomButton, Row, View } from '@rivallapp/volosports-components';
import useDiscoverStore from '../../../../../zustand-stores/DiscoverStore';
import { useUrlParams } from '../../../../../hooks';
import updateFilterCollapsed from '../../../../../zustand-stores/DiscoverStore/actions/updateFilterCollapsed';

const DiscoverVoloPassMembershipPerksFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const collapsed = useDiscoverStore(store => store.filtersCollapsed.voloPassMembershipPerks);
  const voloPassExclusiveOnly = useDiscoverStore(store => store.filters.voloPassExclusiveOnly);

  const toggleFilterCollapsed = () => updateFilterCollapsed('voloPassMembershipPerks', !collapsed);

  const handlePressButton = () =>
    updateUrlParams({ voloPassExclusiveOnly: voloPassExclusiveOnly ? undefined : true });

  return (
    <CollapsibleBase
      isCollapsed={collapsed}
      title="Volo Pass Membership Perks"
      onPress={toggleFilterCollapsed}
    >
      <View flex="wrap" mb="10px">
        <Row alignItems="center" flexWrap="wrap" ml={3.5} space={2} pt={0.5}>
          <CustomButton
            label="Member Exclusive Programs"
            variant="outline"
            style={{ marginBottom: 5 }}
            pressed={voloPassExclusiveOnly}
            onPress={handlePressButton}
          />
        </Row>
      </View>
    </CollapsibleBase>
  );
};

export default DiscoverVoloPassMembershipPerksFilter;
